import React, { Component } from 'react';
import ImportPurchasesComp from '../../../components/purchases/importPurchases';

export default class ImportPurchases extends Component {
	render() {
		return <ImportPurchasesComp />;
	}
}
